import kebabCase from 'lodash.kebabcase';

/**
 * Extract styles from an element
 * @param {Element} element
 * @param {string[]} properties
 * @param {boolean} useKebabCase - HPP requires kebab-case of css properties
 * @param {boolean} useSingleQuotes - It's recommended to have quotes around multi-word fonts
 * @param {boolean} useImportant - If property needs !important to rewrite css styles use true
 * @returns {object}
 */
export default function extractStyles(element, properties = ['color', 'fontFamily', 'fontSize', 'textAlign', 'fontWeight'], useKebabCase = true, useSingleQuotes = true, useImportant = false) {
	if (!element) {
		return {};
	}
	const computedStyle = getComputedStyle(element);
	return properties.reduce((object, property) => {
		let propertyValue = computedStyle[property];
		// Modify font family property
		if (property === 'fontFamily') {
			// Use single quotes (or remove them completely)
			propertyValue = computedStyle[property].replace(/"/g, useSingleQuotes ? '\'' : '').split(',');
		}
		if (useImportant) {
			propertyValue = `${propertyValue} !important`;
		}
		return {
			...object,
			[useKebabCase ? kebabCase(property) : property]: propertyValue
		};
	}, {});
}
